const BASE_URL = process.env.REACT_APP_URL
const BASE_PATH = 'api/v1/file/'

const generateSignedURL = `${BASE_URL}${BASE_PATH}generate-signed-url/`

export default {
  generateSignedURL
}